var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriorty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.71619 4.01984H5.55744V1.31984C5.55744 0.68984 5.21619 0.562339 4.79994 1.03484L4.49994 1.37609L1.96119 4.26359C1.61244 4.65734 1.75869 4.97984 2.28369 4.97984H3.44244V7.67984C3.44244 8.30984 3.78369 8.43734 4.19994 7.96484L4.49994 7.62359L7.03869 4.73609C7.38744 4.34234 7.24119 4.01984 6.71619 4.01984Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorty);
export default __webpack_public_path__ + "static/media/priorty.a2a6771686f84e60eb7c2a57b0a7b378.svg";
export { ForwardRef as ReactComponent };